import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import { ImageUrl } from "../../../utils/constants";
import { StyledBody } from "../../ChallengeDashboardV2/TeamChallengeInvitePopup/styles";
import { StyledModalV2 } from "../../ChallengeDetailsV2/StartChallengePopUp/styles";
import { DownloadReportIcon, RecognitionCloseIcon } from "../../../utils/icons";
import { StyledTitle } from "../../RecogntionAdmin/corevalues/styles";
import dayjs from "dayjs";
import CommonButton from "../../common/CommonButton/CommonButton";
import LazyImage from "../../common/LazyImage/LazyImage";
import { checkImageLoaded } from "../../../utils/methods";

class PreviewImageModal extends Component {
  getFileExtension = (filename) => filename.split(".").pop().toLowerCase();

  downloadFile = async (cloudfrontUrl, documentTitle) => {
    try {
      const response = await fetch(ImageUrl + "/" + cloudfrontUrl, { mode: "cors"});
  
      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
      }
  
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = documentTitle || "download"; // Fallback filename
      document.body.appendChild(downloadLink);
      downloadLink.click();
  
      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(downloadLink);
    } catch (error) {
      window.console.error("Error downloading file:", error);
    }
  };

  downloadHealthDoc = async (document) => {

    checkImageLoaded(ImageUrl+"/"+document.document)
      .then(() => this.downloadFile(document.document, document.document_name))
      .catch(() => this.downloadFile("health-data/health-doc-fallback.png", document.document_name));

  }

  render() {
    const { showModal, onClose, documentData } = this.props;

    return (
      <StyledModalV2
        show={showModal}
        onHide={onClose}
        width={'1000px'}
        style={{top:"-20%"}}
      >
        <Modal.Header onHide={onClose} style={{ background: "#F8F8F8" }}>
          <StyledTitle>{documentData?.document_name || "Preview"}</StyledTitle>
          <div onClick={onClose} style={{ cursor: "pointer" }}>
            {RecognitionCloseIcon()}
          </div>
        </Modal.Header>
        <StyledBody style={{display:"flex",justifyContent:"center", background: "#F8F8F8"}}>
          <LazyImage
            src={`${ImageUrl}/${documentData?.document}`}
            alt="Document Preview"
            fallbackImage={ImageUrl + "/health-data/health-doc-fallback.png "}
            style={{width:"400px",objectFit:"contain"}}
          />
        </StyledBody>
        <div className="health-doc-container">
          <div>
            <span className="upload-date">Upload date: {dayjs(documentData?.created_at).format("MMMM DD, YYYY")}</span>
          </div>
          <div>
            <CommonButton
              btnType={"squareIcon"}
              styles={{color:"white",textColor:"#184A61", padding:"16px 20px", minHeight:"40px", border:"#F37A65",minWidth:"200px", marginLeft:"0px",display:"flex", justifyContent:"center",alignItems:"center"}}
              onClick={() => this.downloadHealthDoc(documentData)}
              title={"Download Report"}
              icon={DownloadReportIcon("#F37A65")}
            />
          </div>

        </div>
      </StyledModalV2>
    );
  }
}

PreviewImageModal.defaultProps = {
  challenge: { name: "", duration: "", body: "" },
};

PreviewImageModal.propTypes = {
  showModal: PropTypes.bool,
  onClose: PropTypes.func,
  documentData: PropTypes.object.isRequired,
  documentData1: PropTypes.object.isRequired,
  title:PropTypes.string
};

export default PreviewImageModal;